<template>
  <b-dropdown
    block
    class="position-picker border"
    :variant="isDarkMode ? 'dark' : 'light'"
  >
    <template #button-content>
      <div class="position-picker--content px-1" v-html="dropdownLabel"></div>
    </template>
    <b-dropdown-item
      v-for="position in callTakerPositions"
      :key="position.position_id"
      :active="position.position_id === callTakerPosition.position_id"
      @click="() => selectPosition(position)"
    >
      <strong>{{ position.sip_id }}</strong>&nbsp;
      <span v-if="position.position_name" style="font-size: 0.85em;">{{ position.position_name }}</span>&nbsp;
      <span v-if="position.assigned_user" style="font-size: 0.85em;">{{ `(${position.assigned_user})` }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import errorHandler from "@/mixins/errorHandler";

export default {
  name: "PositionPicker",
  mixins: [errorHandler],
  data() {
    return {
      callTakerPosition: {},
      callTakerPositions: [],
      fetchAbortController: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("user", ["userCallTakerPosition", "isDarkMode"]),
    dropdownLabel() {
      if (this.isLoading) {
        return "Loading Positions ...";
      } else {
        if (this.callTakerPositions.length > 0) {
          if (this.callTakerPosition.position_id && this.callTakerPosition.position_name) {
            return `<strong>${this.callTakerPosition.sip_id}</strong> <span style="font-size: 0.85em;">${this.callTakerPosition.position_name}</span>`;
          } else if (this.callTakerPosition.position_id && !this.callTakerPosition.position_name) {
            return `<strong>${this.callTakerPosition.sip_id}</strong>`;
          } else {
            return "Select Position";
          }
        } else {
          return "No Positions"
        }
      }
    },
  },
  created() {
    this.fetchPositions();
  },
  methods: {
    selectPosition(position) {
      this.callTakerPosition = { ...position };
      this.$emit("selected", position);
    },
    async fetchPositions() {
      try {
        this.isLoading = true;
        this.fetchAbortController = new AbortController();
        const params = {};
        const res = await this.$ConveyApi.agenciesApi.getAgencyPositions({
          params,
          signal: this.fetchAbortController.signal,
        });
        this.callTakerPositions = res.data.data.map(item => {
          const { position_id, position_name, sip_id, assigned_user } = item;
          return { position_id, position_name, sip_id, assigned_user: assigned_user.trim() };
        });
      } catch(err) {
        if (!this.isApiCanceled(err)) {
          console.log("[PositionPicker:fetchPositions] ERROR: ", err);
        }
      } finally {
        this.isLoading = false;
      }
    }
  },
  beforeDestroy() {
    if (this.fetchAbortController) {
      this.fetchAbortController.abort();
      this.fetchAbortController = null;
    }
  }
};
</script>

<style lang="scss">
.position-picker {
  border-color: #455a64 !important;
  border-radius: 1.5rem;
  
  >button {
    display: flex;
    align-items: center;
  }

  .dropdown-menu {
    min-width: 300px;
    max-width: 80vw;
    max-height: 240px;
    overflow-y: auto;

    .dropdown-item {
      white-space: wrap;
    }
  }

  &--content {
    width: 100%;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>